export default __webpack_public_path__ + "static/media/21.a92514d9.png";